/**
 * LeanIQ Offer Reviews — filter pills + horizontal carousel.
 */
(function () {
  function visibleCards(track) {
    return Array.from(track.querySelectorAll('.liq-reviews__card')).filter(function (card) {
      return !card.hidden;
    });
  }

  function cardStep(track) {
    var cards = visibleCards(track);
    if (!cards.length) return track.clientWidth;
    var first = cards[0];
    var second = cards[1];
    if (second) {
      return Math.round(second.offsetLeft - first.offsetLeft);
    }
    return Math.round(first.getBoundingClientRect().width + 16);
  }

  function setNavDisabled(btn, disabled) {
    if (!btn) return;
    btn.disabled = disabled;
    btn.classList.toggle('is-disabled', disabled);
    btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
  }

  function updateNav(root, track) {
    var prev = root.querySelector('[data-liq-reviews-prev]');
    var next = root.querySelector('[data-liq-reviews-next]');
    if (!prev || !next) return;
    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth - 2);
    var left = track.scrollLeft;
    setNavDisabled(prev, left <= 2);
    setNavDisabled(next, left >= maxScroll);
  }

  function applyFilter(root, track, tag) {
    var cards = track.querySelectorAll('.liq-reviews__card');
    var shown = 0;
    cards.forEach(function (card) {
      var cardTag = (card.getAttribute('data-tag') || '').toLowerCase();
      var match = tag === 'all' || cardTag === tag;
      card.hidden = !match;
      if (match) shown += 1;
    });
    root.classList.toggle('is-empty', shown === 0);
    track.scrollTo({ left: 0, behavior: 'auto' });
    updateNav(root, track);
  }

  function init(root) {
    if (!root || root.dataset.liqReviewsReady === '1') return;
    root.dataset.liqReviewsReady = '1';

    var track = root.querySelector('[data-liq-reviews-track]');
    if (!track) return;

    var filters = root.querySelectorAll('[data-liq-reviews-filter]');
    var prev = root.querySelector('[data-liq-reviews-prev]');
    var next = root.querySelector('[data-liq-reviews-next]');
    var activeTag = 'all';

    filters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activeTag = (btn.getAttribute('data-liq-reviews-filter') || 'all').toLowerCase();
        filters.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        applyFilter(root, track, activeTag);
      });
    });

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -cardStep(track), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: cardStep(track), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', function () {
      updateNav(root, track);
    }, { passive: true });

    window.addEventListener('resize', function () {
      updateNav(root, track);
    }, { passive: true });

    applyFilter(root, track, activeTag);
    requestAnimationFrame(function () {
      updateNav(root, track);
    });
  }

  function boot() {
    document.querySelectorAll('[data-liq-reviews]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-liq-reviews]')
      : null;
    if (root) {
      root.dataset.liqReviewsReady = '';
      init(root);
    }
  });
})();
